import { z } from 'zod';

import { StatsWindowSchema } from '../../stats/stats-range/stats-range';
import { BreakdownRowSchema, ComparableCountSchema } from '../../stats/stats-shapes/stats-shapes';

/** One bucket of the bookings chart, split by status. */
export const BookingVolumePointSchema = z
  .object({
    bucket: z.string(),
    requested: z.number().int().nonnegative(),
    scheduled: z.number().int().nonnegative(),
    completed: z.number().int().nonnegative(),
    cancelled: z.number().int().nonnegative(),
  })
  .strict();

export type BookingVolumePoint = z.infer<typeof BookingVolumePointSchema>;

/** Recorded outcomes of completed bookings. */
export const BookingOutcomeBreakdownSchema = z
  .object({
    attended: z.number().int().nonnegative(),
    noShow: z.number().int().nonnegative(),
    notHeld: z.number().int().nonnegative(),
  })
  .strict();

export type BookingOutcomeBreakdown = z.infer<typeof BookingOutcomeBreakdownSchema>;

/** The Dashboard's Meetings section (D12). */
export const BookingStatsSchema = z
  .object({
    window: StatsWindowSchema,
    requested: ComparableCountSchema,
    scheduled: z.number().int().nonnegative(),
    completed: z.number().int().nonnegative(),
    cancellationRate: z.number().min(0).max(1),
    outcomes: BookingOutcomeBreakdownSchema,
    perBucket: z.array(BookingVolumePointSchema),
    /** By city (`cityKey`) rather than by individual venue — a coded, translatable breakdown. */
    byCity: z.array(BreakdownRowSchema),
  })
  .strict();

export type BookingStats = z.infer<typeof BookingStatsSchema>;
